import axios from 'axios';

// Get backend URL dynamically based on current origin
const getBackendUrl = () => {
  // Always use current origin for API calls
  // This works for any domain (localhost, preview, custom domains)
  // Backend is served from same origin with /api prefix via ingress
  return window.location.origin;
};

const BACKEND_URL = getBackendUrl();
console.log('[API] Using backend URL:', BACKEND_URL);

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
